export const STEP_LOADING = 'loading';
export const STEP_REVIEW = 'review';
export const STEP_RESET = 'reset';

export const PREVIEW_IMAGE_PAINTFILL_COLOR_PLACEMENTS = {
    'Face/Sole': [
        'CrownLogoFaceColor',
        'ToeWeightColor',
        'HeelWeightColor',
        'ScottyCameronLogoSoleColor',
        'CrownLogoSoleColor',
        'FamilyLogoSoleColor',
        'ModelLogoSoleColor',
        // No such thing...
        // 'CrownLogoOutsoleColor',
    ],
    Top: [
        'TopLineColor',
    ],
    Back: [
        'MilledLogoColor',
        'DotHeelColor',
        'DotCenterColor',
        'DotToeColor',
    ],
};
